import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import { Helmet } from 'react-helmet';

class CommissionsUS extends Component {
    render() {
        return (
            <div className="page-pricing-commissions a-flyRightIn">
                <Helmet>
                    <title>Pricing and Commission - TradeUP</title>
                    <meta name="description" content="Discover the pricing system when trading with TradeUP!" />
                </Helmet>
                <h3 className="title">US Stocks</h3>
                <div className="pricing-table-wrap">
                    <Table className="pricing-table">
                        <tbody>
                            <tr>
                                <th>US stocks, ETFs trading Commission</th>
                                <th>
                                    0<sup>1</sup>
                                </th>
                            </tr>
                            <tr>
                                <td>
                                    Transaction Fees<sup>2</sup>
                                </td>
                                <td>
                                    $0.000008<sup>*</sup>Value of Aggregate Sales
                                </td>
                            </tr>
                            <tr>
                                <td>FINRA Trading Activity Fee</td>
                                <td>
                                    $0.000145<sup>*</sup>Quantity Sold with maximum of $7.27/trade
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
                <p className="sm-title">
                    <strong>Notes</strong>
                </p>
                <p className="notes">
                    1. For clients who send an extraordinary number of non-marketable limit orders to the NYSE, and who
                    route such orders direct to NYSE, rather than using Smart routing by our clearing broker, we reserve
                    the right to impose a surcharge in order to defray specialist order handling charges. In this event,
                    we will provide notice to affected clients.
                    <br />
                    2. Transaction fees are only charged for sell orders. Under Section 31 of the Securities Exchange
                    Act of 1934, U.S. national securities exchanges are obligated to pay transaction fees to the SEC
                    based on the volume of securities that are sold on their markets. Exchange rules require their
                    broker-dealer members to pay a share of these fees who, in turn, pass the responsibility of paying
                    the fees to their customers. Only applies to sell transactions and appears on the trade confirmation
                    as: “FEES”. View{' '}
                    <a target="view_window" href="https://www.sec.gov/fast-answers/answerssec31htm.html">
                        more
                    </a>
                    .
                    <br />
                    • VAT, also referred to as consumption tax, goods and services tax, where applicable, will be
                    separately applied for eligible services. <br />• Commissions and fees may change from time to time.
                    TradeUP Securities, Inc. reserves the right to adjust the rates at any time, without given advanced
                    notice.
                </p>
                <h3 className="title">US Options</h3>
                <div className="pricing-table-wrap">
                    <Table className="pricing-table">
                        <tbody>
                            <tr>
                                <th>
                                    US Option Commission<sup>1</sup>
                                </th>
                                <th>
                                    $0.65/contract, with $1.00 minimum<sup>2</sup> per order
                                </th>
                            </tr>
                            <tr>
                                <td>
                                    Option Regulatory Fee (ORF) <sup>3, 4</sup>
                                </td>
                                <td>$0.01925/Contract </td>
                            </tr>
                            <tr>
                                <td>
                                    Transaction Fee (Charged only to sell orders) <sup>5</sup>
                                </td>
                                <td>$0.000008*Value of Aggregate Sales</td>
                            </tr>
                            <tr>
                                <td>FINRA Trading Activity Fee</td>
                                <td>
                                    $0.00244<sup>*</sup>Quantity Sold
                                </td>
                            </tr>
                            <tr>
                                <td>OCC Clearing Fee</td>
                                <td>$0.02/Per contract, with Maximum $55/trade </td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
                <p className="sm-title">
                    <strong>Notes</strong>
                </p>
                <p className="notes">
                    1. Commissions apply to all order types. Commissions are not charged for US exercise and assignment.
                    Commissions are not charged for US cabinet buy-to-close trades.
                    <br />
                    2. Order minimums will be applied to the individual legs of a COMBO order.
                    <br />
                    3. The Option Regulatory Fee (“ORF”) is charged by the following exchanges: AMEX, BATS, BOX, CBOE,
                    CBOE2, EDGX, EMERALD, ISE, GEMINI, MERCURY, MIAX, MERCURY, NOM, NASDAQBX, PSE, PHLX.
                    <br />
                    4. Fee applies to executions which clear in the “Customer” account with OCC. This will generally
                    include Public Customer and Professional Customer transactions.
                    <br />
                    5. Transaction fees are only charged for sell orders. Under Section 31 of the Securities Exchange
                    Act of 1934, U.S. national securities exchanges are obligated to pay transaction fees to the SEC
                    based on the volume of securities that are sold on their markets. Exchange rules require their
                    broker-dealer members to pay a share of these fees who, in turn, pass the responsibility of paying
                    the fees to their customers. Only applies to sell transactions and appears on the trade confirmation
                    as: “FEES”. View{' '}
                    <a target="view_window" href="https://www.sec.gov/fast-answers/answerssec31htm.html">
                        more
                    </a>
                    <br />
                    • Modified orders will be treated as the cancellation and replacement of an existing order with a
                    new order. On certain exchanges, this may have the effect of subjecting modified orders to
                    commission minimums as if they were new orders. For example, if an order for 200 contracts is
                    submitted and 100 contracts execute, then you modify the order and another 100 contracts execute, a
                    commission minimum would be applied to both 100 contract orders.
                    <br />• Options trading entails significant risk and is not appropriate for all investors. Certain
                    complex options strategies carry additional risk. Before trading options, please read
                    <b>
                        <i> Characteristics and Risks of Standardized Options. </i>
                    </b>
                    Supporting documentation for any claims, if applicable, will be furnished upon request.
                    <br />• Commissions and fees may change from time to time. TradeUP Securities, Inc. reserves the
                    right to adjust the rates at any time, without given advanced notice.
                    <br />• Our execution broker IBKR considers exchange fees and/or rebates in determining where to
                    route an order. Under certain circumstances, IBKR may route a marketable order to an exchange that
                    is not currently posting the national best bid or offer (NBBO) but which may be willing to "step up"
                    and execute the order at the NBBO, in order to avoid or reduce the exchange fee for executing the
                    order. If this routing method is used, the client generally will pay a lower execution fee than
                    client would have otherwise paid. In those cases where IBKR routes to an exchange that is not
                    currently posting the NBBO in order to reduce or avoid exchange fees, IBKR will guarantee the client
                    a fill at the NBBO at the time that IBKR routed the order. To view the detailed exchange fee
                    information, please click:{' '}
                    <a target="_blank" href="https://www.interactivebrokers.com/en/index.php?f=1203&nhf=T">
                        https://www.interactivebrokers.com/en/index.php?f=1203&nhf=T
                    </a>
                </p>
                <h3 className="title">Other Fees </h3>
                <div className="pricing-table-wrap">
                    <Table className="pricing-table">
                        <thead>
                            <tr>
                                <th colSpan={2}>Other Fees</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="table-border">
                                <td>Option Exercise & Assignment</td>
                                <td>
                                    0<sup>1</sup>
                                </td>
                            </tr>
                            <tr>
                                <td>Incoming Wire </td>
                                <td>0</td>
                            </tr>
                            <tr>
                                <td>Outgoing Wire</td>
                                <td>
                                    The first time wire out is free for the month, the rest will be charged $10/
                                    transaction<sup>2</sup>
                                </td>
                            </tr>
                            <tr>
                                <td>ACH Deposit / Withdraw </td>
                                <td>
                                    ACH deposit is free of charge. The first time ACH withdraw per calendar month is
                                    free. Subsequent withdrawals are charged $1.00/transaction.
                                </td>
                            </tr>
                            <tr>
                                <td>ACATS Transfer In</td>
                                <td>
                                    0<sup>3</sup>
                                </td>
                            </tr>
                            <tr>
                                <td>ACATS Transfer out</td>
                                <td>0</td>
                            </tr>
                            <tr>
                                <td>FOP Transfer In & Out</td>
                                <td>0</td>
                            </tr>
                            <tr>
                                <td>DRS Deposit</td>
                                <td>$25/settled transaction; $100/ rejected transaction</td>
                            </tr>
                            <tr>
                                <td>DRS Withdraw</td>
                                <td>$5/settled transaction; free for rejected transaction</td>
                            </tr>
                            <tr>
                                <td>Rights or Warrants Exercise Fee</td>
                                <td>0</td>
                            </tr>
                            <tr>
                                <td>ACH Bounce Fee</td>
                                <td>0</td>
                            </tr>
                            <tr>
                                <td>Wire Return Fee</td>
                                <td>0</td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
                <p className="sm-title">
                    <strong>Notes</strong>
                </p>
                <p className="notes">
                    1. TradeUP Securities, Inc. does not charge an option exercise or assignment fee. Certain
                    transactions are subject to the standard commissions for the applicable products.
                    <br />
                    2. TradeUP Securities, Inc. withdrawal fees do not cover third-party fees. The account holder will
                    be solely responsible for any fees assessed by a beneficiary or correspondent bank. In addition,
                    processing fees charged by your bank or its correspondent bank, which are not included in TradeUP
                    Securities, Inc. withdrawal fees, may be deducted from wire proceeds.
                    <br />
                    3. While TradeUP Securities, Inc. does not charge for incoming or outgoing ACATS transfers, customer
                    should consult with their sending or receiving firm to determine if there will be any applicable
                    fees for the transfer.
                    <br />
                    4. All the fees are pass-through charges from TradeUP Securities, Inc.’s clearing firm. TradeUP
                    Securities, Inc. and the clearing firm reserve the right to adjust the rates at any time, without
                    given advanced notice.
                </p>
            </div>
        );
    }
}

export default CommissionsUS;
